import {
  CreateTransactionDto,
  DeleteTransactionDto,
  EditTransactionDto,
  GetTransactionDto,
  MessageResponseDto,
  TransactionApiFp,
  TransactionControllerGet200Response,
  VoidTransactionDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseTransactionModel = TransactionControllerGet200Response;
export type GetTransactionModel = GetTransactionDto;
export type MutateResponseTransactionModel = MessageResponseDto;
export type CreateTransactionModel = CreateTransactionDto;
export type UpdateTransactionModel = EditTransactionDto;
export type DeleteTransactionModel = DeleteTransactionDto;
export type VoidTransactionModel = VoidTransactionDto;

export const apiTransactionFp = TransactionApiFp(apiConfig);
export const getTransactionController = apiTransactionFp.transactionControllerGet;
export const createTransactionController = apiTransactionFp.transactionControllerCreate;
export const updateTransactionController = apiTransactionFp.transactionControllerEdit;
export const deleteTransactionController = apiTransactionFp.transactionControllerDelete;
export const voidTransactionController = apiTransactionFp.transactionControllerVoid;

export const QueryKeyTransaction = QueryKey.Transaction;
